import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'preview']

  connect() {
    // this.inputTarget.addEventListener('change', this.previewImage.bind(this))
  }

  previewImage(event) {
    console.log(event)
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e) => {
        if (this.hasPreviewTarget) {
          this.previewTarget.src = e.target.result
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }
}
